export default {
  startEvent: 'load', // 監聽網頁讀取事件 DOMContentLoaded(較快), load(較慢)
  once: false, // 重複出現
  mirror: true, // 重複出現
  delay: 0,
  duration: 400,
}
